<template>
  <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40" style="z-index: 200;">
    <div class="bg-white p-6 rounded-lg w-96 shadow-xl">
      <h2 class="text-lg font-bold mb-4">Switch Organization</h2>
      <p class="text-gray-700 mb-6">
        Do you want to switch to <span class="font-semibold">{{ orgData.organizationName }}</span>?
      </p>
      <div class="flex justify-end gap-3">
        <button
          @click="$emit('close')"
          class="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300"
        >
          No
        </button>
        <button
          @click="switchOrg"
          class="px-4 py-2 rounded bg-primary text-white hover:opacity-90"
        >
        Switch
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MyJobApp from '@/api/MyJobApp.js'
import {setCookiesWithExpire} from '@/utils/cookies.js'


export default {
  name: 'userSwitchPermissionDialog',
  props: {
    orgData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    switchOrg () {
        console.log("check the data 1", this.orgData.orgId,)
    //   this.$store.dispatch('SetLoader', { status: true, message: 'Switching...' })
      MyJobApp.SwitchUser(
        this.orgData.orgId,
        response => {
          console.log("check the data 1", this.orgData.orgId, response)
          this.$store.dispatch('SetLoader', { status: false, message: '' })
          let latLong = {
            latitude: response.Data.organizationAddress.latitude,
            longitude: response.Data.organizationAddress.longitude
          };

          let LoginUserlatLong = null;
          if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                LoginUserlatLong = {
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude
                };
                localStorage.setItem('LoginUserlatLong', JSON.stringify(LoginUserlatLong));
              },
              (error) => console.error(`Geolocation error: ${error.message}`)
            );
          }

          localStorage.setItem('orgInfo', JSON.stringify(latLong));
          localStorage.setItem('jobUserInfo', JSON.stringify(response.Data.userInfo));
          setCookiesWithExpire('jobAuthToken', response.Data.userInfo.authToken, 30);
          
          this.$store.dispatch('SetAlert', {
            showAlert: true, 
            message: 'Logged in successfully', 
            color: 'success'
          });
          this.$store.dispatch('SetLoader', { status: false, message: '' });
          if (response.Data.redirectTo === "employee") {
            this.$router.push({ name: 'dashboard1' });
          }
        },
        (error) => {
          this.$store.dispatch('SetLoader', { status: false, message: '' })
          this.$store.dispatch('SetAlert', {
            showAlert: true,
            message: error.message,
            color: 'error'
          })
        }
      )
    }
  }
}
</script>
